<template>
    <div v-if="showCountdown" class="alert" :class="updatedBackground">
        <i class="fa-lg fa-solid my-3 my-sm-0 me-2 fa-triangle-exclamation"></i>
        <small>Order in the next <b><span v-if="hours > 0">{{ hours }} hour{{ hours == 1 ? '' : 's' }}</span> <span v-if="minutes > 0">{{ minutes }} minute{{ minutes == 1 ? '' : 's' }}</span> <span v-if="hours == 0 && minutes == 0"> {{ seconds }} second{{ seconds == 1 ? '' : 's' }}</span></b> to get your tyres fitted at your chosen appointment time.</small>
    </div>
</template>

<script>
    import dayjs from '@frontend/node_modules/dayjs';

    export default {
        props: ['fitter', 'background'],
        data() {
            return {
                hours: null,
                minutes: null,
                seconds: null,
                showCountdown: false,
                updatedBackground: this.background
            }
        },
        mounted() {
            this.calculateCutOffTime();

            let vm = this;

            setInterval(function() {
                vm.calculateCutOffTime();
            }, 1000);
        },
        methods: {
            calculateCutOffTime: function() {
                var duration = require('@frontend/node_modules/dayjs/plugin/duration');
                dayjs.extend(duration);

                var now = dayjs().format('YYYY-MM-DD H:mm:ss');
                var cutOff = dayjs(this.fitter.cut_off).format('YYYY-MM-DD H:mm:ss');

                if(dayjs().isBefore(cutOff)) {
                    this.hours = parseInt(dayjs.duration(dayjs(cutOff).diff(now)).format('HH'));
                    this.minutes = parseInt(dayjs.duration(dayjs(cutOff).diff(now)).format('mm'));
                    this.seconds = parseInt(dayjs.duration(dayjs(cutOff).diff(now)).format('s'));

                    if(this.hours == 0) {
                        this.updatedBackground = 'alert-danger';
                    }

                    this.showCountdown = true;
                }
                else {
                    this.showCountdown = false;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>